import React, { useContext, useEffect, useState } from "react";
import ApplicationContext from "../../../context/index";
import CircularProgress from "@mui/material/CircularProgress";
import DedupeForm from "./indexForm";
// import NotificationMessage from "../../../components/notification";
import SectionTitle from "../../../components/sectionTitle";
import { Box } from "@mui/material";
import {
  getRoute,
  getStorageItem,
  makeid,
  setStorageItem,
} from "../../../helpers/utils";
import { useHistory } from "react-router";
import { postWebService } from "../../../helpers/server";
import { buildWrapperTokenHeader } from "../../../helpers/lead";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";

function Dedupe({ classes: { loaderBox, main } }) {
  const { state, dispatch } = useContext(ApplicationContext);
  const history = useHistory();

  const [errors, setErrors] = useState([]);
  const [modal, setModal] = useState({ open: false, snackbar: false });
  const [isLoaded, setIsLoaded] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [result, setResult] = useState(null);

  const [terminateMessage] = useState(
    "Journey has been terminated because the customer does not want to continue with the revised sum assured which has been calculated using customer's annual income."
  );

  useEffect(() => {
    wrapperToken();
  }, []);

  const wrapperToken = async () => {
    try {
      const header = buildWrapperTokenHeader();
      const response = await postWebService("token.php", {}, header);

      setStorageItem("access-token", response.data.access_token);
      getOrder();
    } catch (error) {
      // console.log(error);
    }
  };

  const getOrder = async () => {
    try {
      const checksum = makeid();
      const response = await postWebService("orders.php", {
        checksum,
        oid: getStorageItem("oid"),
      });
      const { data } = response;
      const str = data.data.slice(9, -8);
      const result = JSON.parse(atob(str));
      if (result.checksum === checksum) {
        console.log(result);
        setOrderDetails(result);
        fetchDedupeDetails();
      }
    } catch (error) {
      setIsLoaded(true);
    }
  };

  const successDedupeDetails = ({ data = null }) => {
    setIsLoaded(true);

    if (data?.consent == 1 && data?.status == 1) {
      console.log("if valid data");
      navigateTo();
    } else {
      setResult(data?.data);

      if (!data?.data) {
        console.log("else null data");
        navigateTo();
      }
    }
  };

  const fetchDedupeDetails = async () => {
    try {
      const checksum = makeid();
      const response = await postWebService("dedupe.php", {
        checksum,
        oid: getStorageItem("oid"),
      });

      console.log(response);

      successDedupeDetails(response);
    } catch (error) {
      setIsLoaded(true);
    }
  };

  /* Start: Submit Decision */
  const cbSuccess = (data = null) => {
    setIsFormSubmitted(false);

    if (data?.code == 200) {
      navigateTo();
    } else if (data?.code == 403) {
      terminateJourney(
        data?.msg ??
          "Your journey has been terminated as total premium exceeds allowed premium."
      );
    } else {
      setErrors(
        data?.msg ??
          "Unable to process your request. Please contact the support team for assistance."
      );
    }
  };

  const cbError = (error = "An error occured, please try again.") => {
    setIsFormSubmitted(false);
    setErrors(new Array(error));
  };

  const onSubmit = async (consent) => {
    try {
      setIsFormSubmitted(true);

      const checksum = makeid();
      const response = await postWebService("dedupe-decision.php", {
        checksum,
        oid: getStorageItem("oid"),
        consent,
      });

      cbSuccess(response.data);
    } catch (error) {
      cbError(error);
    }
  };

  const terminateJourney = (message = "") => {
    setStorageItem("journeyCloseReason", message);

    navigateTo("terminated");
  };
  /* End: Submit Decision */

  const navigateTo = (url = "existingPolicies") => {
    history.push({ pathname: getRoute(url) });
  };

  return isLoaded ? (
    <Box className={main} p={0}>
      <Box mt={2}>
        <Box display="flex" justifyContent="center" m={2} mt={1} mb={0}>
          <SectionTitle title={"Customer Verification"} />
        </Box>

        <DedupeForm
          errors={errors}
          isFormSubmitted={isFormSubmitted}
          modal={modal}
          onSubmit={onSubmit}
          orderDetails={orderDetails}
          result={result}
        />
      </Box>
    </Box>
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(Dedupe);
